// lib
import { Firestore } from "lib/firebase";

// db connection
import { ProductController } from "controllers";


export const categories = [
    'blazers_jackets',
    'tops_shirts_blouses',
    'skirts', 'trousers_shorts',
    'jumpers_knitwear', 'dresses_jumpsuits'
];

export const getRecommendation = async ({ customer }) => {
    const result =
        await Firestore.collection('users')
            .doc(customer.id).collection('recommendations')
            .orderBy('timestamp', 'desc')
            .limit(1)
            .get();

    const data = result.docs.map((res) => Object({
        id: res.id,
        customerId: customer.id,
        ...res.data()
    }))[0];

    if (data && Object.keys(data).length) {
        return data;
    }

    return null;
}

/**
 *
 * Set value for all recommendations available to false
 */
export const setAllRecommendationsValue = async ({ recommendation, barcode }) => {

    const res = await Firestore.collectionGroup('recommendations').get();
    const data = res.docs.map((res) => Object({
        ref: res.ref,
        ...res.data()
    })).filter((res) => res.ref.id !== recommendation.id);

    for (const item of data) {

        for (const category of categories) {
            const categoryData = item[category];

            if (!categoryData) { continue; }

            const z = categoryData.findIndex((i) => i.barcode === barcode);
            if (z === -1) { continue; }

            categoryData[z] = { ...categoryData[z], available: false };
        }

        const { ref, ...payload } = item;
        await ref.update(payload);
    }
}

export const setRecommendation = async ({ recommendation }) => {
    const { id, customerId, ...payload } = recommendation;

    await Firestore.collection('users')
        .doc(customerId).collection('recommendations')
        .doc(id).set(payload);
}

export const getProduct = async ({ barcode }) => {
    if (!barcode) { return null; }

    return await ProductController.getProduct(barcode);
}

export const setProductAsReserved = async ({ barcode, customer }) => {
    const product = await getProduct({ barcode });

    if (!product || !customer) {
        return;
    }

    if (product.status !== 'available'
        || product.currentUser
        || product.currentBox) {
        return;
    }

    await ProductController.setProduct(barcode, {
        status: 'reserved',
        currentUser: customer.id
    });

    return true;
}
